//CSS
import "../../Components/Page/Page.css";


//React
import React from "react";
import SecHeader from "../../Components/SecHeader/SecHeader";
import SubSection from "../../Components/Section/SubSection";

//Data
import QuoteComp from "../../Components/QuoteComp/QuoteComp";

const RevenueScenario: React.FC = () => {
    return (
        <div className="sectionContainer">
            <SecHeader title="Revenue Scenario" />
            <SubSection>
                {/* <ImageComp imageSource={approach} width={"Clamp(18rem, 25vw, 36rem)"} /> */}
                <QuoteComp text={"Using one of the 25 global car companies (GM is #6) as an example – since Wankel in the 1960 licensed IP to all of them, – including to GM, a license for exclusivity and prototyping for $50-million, ($400-million in todays money)"} />
                <div className="description-container">
                    <b>1) Software (E-SPEC SaaS) & Data</b>
                    <p>
                        $1-million for 3-yrs. access to our data (R&D + Current) + design tools to 
                        quickly see what they gain with ELF-Tech, – and what they risk by not using it
                    </p>{" "}
                    <b>2) Parts’ CADs Sales (From Our Growing Library)</b>
                    <p>
                        $10-million for prototyping and building test engines, and $100-million for US 
                        exclusivity for 2 years (if desired)
                    </p>{" "}
                    <b>3) Prototyping Licenses (+/- Exclusivity)</b>
                    <p>
                        E-SPEC users can explore how ELF-Tech innovations give their product the best 
                        edge in power, weight, efficiency, emissions and costs. This will become the 
                        “must use” global gold standard, and it will be the only product with all the 
                        ELF-Tech design data.
                    </p>{" "}
                    <b>4) Production Licenses</b>
                    <p>
                        From our library of parts Computer Aided Designs (CAD)s
                    </p>{" "}
                </div>
            </SubSection>
        </div>
    );
};

export default RevenueScenario;